import React from "react";

import { CustomFormattedMessage } from "@src/utility/context/CustomFormattedMessage";
import FadeLoader from "react-spinners/FadeLoader";
import AppIcon from "@vcomponents/AppIcon";

import "./style.scss";
/**
 * APP PRIMARY BUTTON
 * @param {Object} props
 * @param {String} props.text
 * @param {Element} props.icon
 * @param {Function} props.onClick
 * @param {String} props.className
 * @param {Boolean} props.disabled
 * @param {Boolean} props.isLoading
 * @param {Boolean} props.showLoadingText
 * @param {String} props.loadingText
 * @param {String} props.loaderColor
 *
 * @returns JSX.ELEMENT => button
 */

const AppButton = (props) => {
  const btnClasses = `app-btn ${props.className} ${
    props.disabled ? "disabled" : ""
  } ${props.isLoading ? "isLoading" : ""}`;
  const btnText = props.isLoading
    ? props.showLoadingText
      ? props?.loadingText
      : "Loading..."
    : props.text;
  const iconId =
    props?.icon && props?.label ? props.label.replace(/\s+/g, "_") : "";
  return (
    <button
      disabled={props?.disabled}
      onClick={props.onClick}
      className={btnClasses}
      type={props?.type || "button"}
      {...(props?.id ? { id: props?.id } : {})}
    >
      {props.icon && !props.isLoading && (
        <AppIcon
          id={iconId}
          tooltipPlacement={props?.tooltipPlacement}
          tooltip={!!props?.tooltip}
          label={props?.label}
          icon={props.icon}
        />
      )}
      {props.isLoading && (
        <div className="loader">
          <FadeLoader
            color={props?.loaderColor || "#FFFFFF"}
            height={3}
            margin={-14}
            radius={3}
            width={2}
          />
        </div>
      )}
      {props.text && (
        <span className={`text ${props?.textClassName || ""}`}>
          <CustomFormattedMessage id={btnText} defaultMessage={btnText} />
        </span>
      )}

      {props.trailingIcon && !props.isLoading && (
        <AppIcon
          id={iconId}
          icon={props.trailingIcon}
          className="trailing-icon"
        />
      )}
      {props?.badge ? (
        <div className="app-btn__badge">{props?.badge}</div>
      ) : null}
    </button>
  );
};

export default AppButton;
